import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import { useTranslation } from "react-i18next";

// تحديد سكيمه التحقق باستخدام Yup
const schema = yup.object().shape({
  CurrentPassword: yup.string().required("Current password is required"),
  NewPassword: yup
    .string()
    .required("New password is required")
    .min(6, "Password must be at least 8 characters long"),
  ConfirmPassword: yup
    .string()
    .oneOf([yup.ref("NewPassword"), null], "Passwords must match")
    .required("Confirm password is required"),
});
export default function ChangePasswordModal({ open, handleClose }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const response = await axios.post(
        "https://tarabotcs.com-eg.net/api/Users/V1/ChangePassword",
        {
          CurrentPassword: data.CurrentPassword,
          NewPassword: data.NewPassword,
          ConfirmPassword: data.ConfirmPassword,
        },
        {
          headers: {
            CompanyID: "221005",
            AccessToken: userData.Data.AccessToken,
          },
        }
      );

      if (response.data.Success) {
        alert("Password changed successfully");
        handleClose();
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("userData");
        alert("Session expired. Please log in again.");
        navigate("/");
      } else {
        console.error("Error changing password:", error);
      }
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle
        sx={{
          textAlign: "center",
          fontSize: "22px",
          color: "#263150",
          fontWeight: "bold",
        }}
      >
        {t("changePassword")}
      </DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label={t("currentPassword")}
            type="password"
            fullWidth
            {...register("CurrentPassword")}
            error={!!errors.CurrentPassword}
            helperText={errors.CurrentPassword?.message}
          />
          <TextField
            margin="dense"
            label={t("newPassword")}
            type="password"
            fullWidth
            {...register("NewPassword")}
            error={!!errors.NewPassword}
            helperText={errors.NewPassword?.message}
          />
          <TextField
            margin="dense"
            label={t("confirmPassword")}
            type="password"
            fullWidth
            {...register("ConfirmPassword")}
            error={!!errors.ConfirmPassword}
            helperText={errors.ConfirmPassword?.message}
          />
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "center", gap: 1.5, pb: 2, pt: 1 }}>
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={{
              borderColor: "#cbd5e1",
              color: "#64748b",
              borderRadius: "8px",
              px: 3,
              fontWeight: 600,
              "&:hover": { borderColor: "#94a3b8", backgroundColor: "#f8fafc" },
            }}
          >
            {t("cancel")}
          </Button>
          <Button
            type="submit"
            variant="contained"
            sx={{
              backgroundColor: "#2563eb",
              color: "white",
              borderRadius: "8px",
              px: 3,
              fontWeight: 700,
              "&:hover": { backgroundColor: "#1d4ed8" },
            }}
          >
            {t("save")}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
